exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout-button[data-v-e4e99140] {\n  margin-bottom: 64px;\n}\n.checkout-button__button[data-v-e4e99140] {\n  height: var(--custom-control-height);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--size-sm);\n}", ""]);

// exports
